<img src="{{loadingImg}}" alt="Loading..." height="100px">